import React, { useEffect, useState } from "react";
import Header from "../header/header";
import FooterComponent from "../footerComponent/footerComponent";
import Typography from "@mui/material/Typography";
import "./profiles.scss";
import HeaderImageSection from "../shared/headerImageSection";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import dummyImg from "../../assets/committeeProfileImg.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams, useNavigate } from "react-router-dom";
import UploadIcon from "@mui/icons-material/Upload";
import axios from "axios";
import { API_URL, Website_URL } from "../../variables";
import DialogBox from "../shared/dialog/dialogBox";
import { ToastContainer, toast } from "react-toastify";
import ImageCarousel from "../shared/imageCarousel/imageCarousel";

const ProfileCompleteInfo = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const [profileInfo, setProfileInfo] = useState([]);
  const [showAllInfo, setShowAllInfo] = useState(false);
  const [showGetContactConfirmation, setShowGetContactConfirmation] =
    useState(false);
  //   const profileId = profileInfo.member_id;
  useEffect(() => {
    window.scrollTo(0, 0);
    getProfileDetails();
  }, []);

  const getProfileDetails = async () => {
    let res = await axios.post(API_URL + "my_profile?member_id=" + id);
    if (res?.data) setProfileInfo(res?.data.body[0]);
  };

  //   const getSubscriptionInfo = async () => {
  //     let res = await axios.post(
  //       API_URL +
  //         "getcontact?member_id=" +
  //         localStorage.getItem("member_id")?.toUpperCase() +
  //         "&req_member_id=" +
  //         id.toUpperCase()
  //     );
  //     console.log("response..........", res?.data.message);
  //     if (
  //       res?.data.message.includes(
  //         "Subscription limit updated successfully. Profile details saved"
  //       )
  //     ) {
  //       setShowGetContactConfirmation(false);
  //       setShowAllInfo(true);
  //       setShowGetContact(false);
  //     }
  //     if (res?.data.message.includes("is already in profiles taken")) {
  //       setShowGetContactConfirmation(false);
  //       setShowGetContact(false);
  //       toast.error(res?.data.message, {
  //         position: "top-center",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "light",
  //       });
  //     }
  //   };

  const hideConfirmation = (value) => {
    setShowGetContactConfirmation(false);
  };

  const confirmRequest = async (value) => {
    if (value) {
      //getSubscriptionInfo();
    }
  };

  return (
    <>
      <Header />
      <HeaderImageSection />
      <ToastContainer />
      <section className="formSection bg-white p-4">
        <div className="row">
          <div className="col-md-9 accordianDetails p-3">
            <div className="d-flex flex-row">
              <div>
                {/* <span className="backBtn mr-3">
                  <WestIcon className="mr-2" />
                  <Link to="/search">Back</Link>
                </span> */}
                <label className="textDarkRed font22px font-bold">
                  Register No / नोंदणी क्र - {profileInfo.member_id} (
                  {profileInfo?.last_name?.toUpperCase()})
                </label>
              </div>
              <div className="text-right flex-grow-1">
                <span
                  className="getContactBtn cusorPointer"
                  onClick={() => {
                    navigate("/login");
                    //setShowGetContactConfirmation(true);
                  }}
                >
                  Get Contact
                </span>
                <span
                  className="backBtn ml-3 cursorPointer"
                  onClick={() => {
                    let sharedURL = Website_URL + "profileCompleteInfo/" + id;
                    navigator.clipboard.writeText(sharedURL);
                    toast.success(
                      "Profile ID link is copied, you can share it.",
                      {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      }
                    );
                  }}
                >
                  <UploadIcon className="mr-2" />
                  Share
                </span>
              </div>
            </div>
            <div className="row p-2">
              <div className="col-md-3 p-1">
                {profileInfo?.images?.length > 0 ? (
                  <ImageCarousel carouselData={profileInfo.images} />
                ) : (
                  <img alt="" className="profileImg" src={dummyImg} />
                )}
              </div>
              <div className="col-md-9 profileData p-1">
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed">
                      CONTACT DETAILS / संपर्क तपशील
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>First Name / पहिले नाव</label>
                        <label
                          className={
                            showAllInfo
                              ? "text-capitalize textDarkRed font-bold"
                              : "textBlur text-capitalize textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                      <div className="col">
                        <label>Middle Name / मधले नाव</label>
                        <label
                          className={
                            showAllInfo
                              ? "text-capitalize textDarkRed font-bold"
                              : "textBlur text-capitalize textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                      <div className="col">
                        <label>Last Name / आडनाव</label>
                        <label
                          className={
                            showAllInfo
                              ? "text-capitalize textDarkRed font-bold"
                              : "textBlur text-capitalize textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>
                          Primary contact number / प्राथमिक संपर्क क्रमांक
                        </label>
                        <label
                          className={
                            showAllInfo
                              ? "textDarkRed font-bold"
                              : "textBlur textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          Secondary contact number / दुय्यम संपर्क क्रमांक
                        </label>
                        <label
                          className={
                            showAllInfo
                              ? "textDarkRed font-bold"
                              : "textBlur textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          *E-mail ID (Its important) / *ई-मेल आयडी (त्याचा
                          महत्त्वाचा):
                        </label>
                        <label
                          className={
                            showAllInfo
                              ? "textDarkRed font-bold"
                              : "textBlur textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                      <div className="col-md-12 col-sm-12">
                        <label>Residence Address / निवासाचा पत्ता</label>
                        <label
                          className={
                            showAllInfo
                              ? "textDarkRed font-bold"
                              : "textBlur textDarkRed font-bold"
                          }
                        >
                          ""
                        </label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed">
                      PERSONAL DETAILS / वैयक्तिक माहिती
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>First Name / पहिले नाव</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.first_name
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                      <div className="col">
                        <label>Middle Name / मधले नाव</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.middle_name
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                      <div className="col">
                        <label>Last Name / आडनाव</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.last_name
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                      <div className="col">
                        <label>Height / उंची (ft: inch)</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.heightFt
                            ? profileInfo.heightFt + " feet"
                            : ""}{" "}
                          {profileInfo.heightInch
                            ? profileInfo.heightInch + " inches"
                            : ""}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Blood Group / रक्त गट</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo?.blood_group?.toUpperCase()}
                        </label>
                      </div>
                      <div className="col">
                        <label>Spectacles / चष्मा</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.spectacles}
                        </label>
                      </div>
                      <div className="col">
                        <label>Weight / वजन(KG)</label>
                        <label className="textDarkRed">
                          {profileInfo.weight}
                        </label>
                      </div>
                      <div className="col">
                        <label>Maritial Status / वैवाहिक स्थिती /</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.maritial_status}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Diet / आहार</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.diet}
                        </label>
                      </div>
                      <div className="col">
                        <label>Gender / लिंग</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.gender}
                        </label>
                      </div>
                      <div className="col">
                        <label>Physical disability / शारीरिक अपंगत्व</label>
                        <label className="textDarkRed font-bold font-bold text-capitalize">
                          {profileInfo.physical_disability}
                        </label>
                      </div>
                      <div className="col">
                        <label>Complexion / रंग </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.complexion}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Mother Tongue / मातृभाषा</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.mother_tongue}
                        </label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed font-bold">
                      HOROSCOPE DETAILS / कुंडली तपशील
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>Rashi / राशी</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.rashi}
                        </label>
                      </div>
                      <div className="col">
                        <label>Nakshatra / नक्षत्र</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.nakshatra}
                        </label>
                      </div>
                      <div className="col">
                        <label>Charan / चरण</label>
                        <label className="textDarkRed font-bold ">
                          {profileInfo.charan}
                        </label>
                      </div>
                      <div className="col">
                        <label>Nadi / नाडी</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.nadi}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Gan / गण</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.gan}
                        </label>
                      </div>
                      <div className="col">
                        <label>Date of birth / जन्मतारीख</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.dob}
                        </label>
                      </div>
                      <div className="col">
                        <label>Birthplace / जन्मस्थान</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo?.birthplace}
                        </label>
                      </div>
                      <div className="col">
                        <label>Birth Time / जन्मवेळ*</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo?.birth_time}
                        </label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed font-bold">
                      Educational / Professional Details / शैक्षणिक / व्यावसायिक
                      तपशील:
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>Education Area / शिक्षण क्षेत्र</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.education_area}
                        </label>
                      </div>
                      <div className="col">
                        <label>Education / शिक्षण</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo?.education?.toUpperCase()}
                        </label>
                      </div>
                      <div className="col">
                        <label>Occupation / व्यवसाय</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.occupation}
                        </label>
                      </div>
                      <div className="col">
                        <label>Income / उत्पन्न</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo?.income_amt}{" "}
                          {profileInfo?.income_type?.toUpperCase()}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Country / व्यवसाय देश</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.country}
                        </label>
                      </div>
                      <div className="col">
                        <label>State / राज्य</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.state}
                        </label>
                      </div>
                      <div className="col">
                        <label>City / शहर</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          Pune
                        </label>
                      </div>
                      <div className="col">
                        <label>&nbsp;</label>
                        <label className="textDarkRed font-bold"></label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed font-bold">
                      Address / पत्ता
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>
                          Primary contact number / प्राथमिक संपर्क क्रमांक
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.mobile_no
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          Secondary contact number / दुय्यम संपर्क क्रमांक
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.sec_mobile
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <label>Residence Address / निवासाचा पत्ता/</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.address
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                      <div className="col-md-4">
                        <label>
                          *E-mail ID (Its important) / *ई-मेल आयडी (त्याचा
                          महत्त्वाचा):
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.email
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed font-bold">
                      Family Background / कौटुंबिक पार्श्वभूमी
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>Father / वडील</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.father}
                        </label>
                      </div>
                      <div className="col">
                        <label>Mother / आई</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.mother}
                        </label>
                      </div>
                      <div className="col">
                        <label>Brothers / भाऊ</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.brother}
                        </label>
                      </div>
                      <div className="col">
                        <label>Married Brothers / विवाहित भाऊ </label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.married_brother}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Sisters / बहिणी</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.sister}
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          <span class="extraInfo-1Y8HL">
                            Married Sisters / विवाहित बहिणी
                          </span>
                        </label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.married_sister}
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          <span class="extraInfo-1Y8HL">
                            Parents Fullname / पालकांचे पूर्ण नाव:
                          </span>
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {showAllInfo ? (
                            profileInfo.parents_full_name
                          ) : (
                            <span className="textBlur">Hide Text</span>
                          )}
                        </label>
                      </div>
                      <div className="col">
                        <label>Parents Occupation / पालकांचा व्यवसाय</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.parents_occupation}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Parents Resident City / पालक निवासी शहर</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.parents_resident_city}
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          *Native District (Its important) / *मूळ जिल्हा
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.native_district}
                        </label>
                      </div>
                      <div className="col">
                        <label>Native Taluka, If Any / मूळ तालुका</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.native_taluka}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>
                          Surnames of Relatives / नातेवाईकांची आडनावे
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.relative_surnames}
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          Mama’s Surname / Place / आईचे आडनाव / ठिकाण
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.mama_surname}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>
                          Any Intercast Marriage in Core Family / मूळ कुटुंबात
                          कोणताही आंतरजातीय विवाह :
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.intercast_marriage}
                        </label>
                      </div>
                      <div className="col">
                        <label>
                          If yes (Relation/Caste) / जर होय (नाते/जात):
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.caste}
                        </label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="accordianHeader"
                  >
                    <Typography className="textDarkRed font-bold">
                      Expectation / अपेक्षा
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordianDetails profileDetails">
                    <div className="row">
                      <div className="col">
                        <label>Preferred Cities / पसंतीची शहरे</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.preffered_cities}
                        </label>
                      </div>
                      <div className="col">
                        <label>Mangal / मंगल</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.exp_mangal}
                        </label>
                      </div>
                      <div className="col">
                        <label>Height / उंची (ft: inch)</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.exp_heightFt
                            ? profileInfo.exp_heightFt + " feet"
                            : "-"}{" "}
                          {profileInfo.exp_heightInch
                            ? profileInfo.exp_heightInch + " inches"
                            : "-"}
                        </label>
                      </div>
                      <div className="col">
                        <label>Diet / आहार</label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.diet}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Expected Education / अपेक्षित शिक्षण </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.exp_education}
                        </label>
                      </div>
                      <div className="col">
                        <label>Maritial Status / वैवाहिक स्थिती </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.exp_maritial_status}
                        </label>
                      </div>
                      <div className="col">
                        <label>Max Age Difference / कमाल वय फरक</label>
                        <label className="textDarkRed font-bold">
                          {profileInfo.exp_age_diff}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12">
                        <label>
                          Expected Occupation & Income per Annum / अपेक्षित
                          व्यवसाय आणि वार्षिक उत्पन्न{" "}
                        </label>
                        <label className="textDarkRed font-bold text-capitalize">
                          {profileInfo.exp_occupation_income}
                        </label>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <label className="d-block mt-3 pl-3 mb-0">
                  Committee Member / समिती सदस्य
                </label>
                <label className="textDarkRed font-bold text-capitalize pl-3">
                  {profileInfo.committee_member}
                </label>
              </div>
            </div>
          </div>
          <div className="col-md-3 p-3">
            <label className="textDarkRed">
              For more information kindly go through the below videos or contact
              us
            </label>
            <div className="p-2 mb-3">
              <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                <PlayCircleIcon className="playIcon" />
              </div>
              <label className="textDarkRed font18px font-bold">
                How to login
              </label>
            </div>
            <div className="p-2 mb-3">
              <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                <PlayCircleIcon className="playIcon" />
              </div>
              <label className="textDarkRed font18px font-bold">
                How to register yourself
              </label>
            </div>
          </div>
        </div>
      </section>
      <DialogBox
        open={showGetContactConfirmation}
        content="Please confirm you want to get contact details, as your subscription count will decrease?"
        heading="Confirmation"
        button1="Confirm"
        button2="Cancel"
        confirmRequest={confirmRequest}
        hideConfirmation={hideConfirmation}
      />
      <FooterComponent />
    </>
  );
};
export default ProfileCompleteInfo;
